/**
 * Determines how the category tree is presented.
 * - CONFIGURATION: Used in configuration screens where categories can be enabled/disabled.
 * - DISPLAY: Used in display screens where categories are simply navigated, displayed without any controls or decorations.
 * - CALCULATION: Used in a calculation context when the element is readonly.
 */
export enum CategoryTreePresentationMode {
  CONFIGURATION,
  DISPLAY,
  CALCULATION,
}
